<template>
  <main class="image-upload-page">
    <section class="upload-grid" aria-label="图片资料上传">
      <label v-for="item in uploads" :key="item.key" class="upload-item">
        <span class="preview-box">
          <img
            v-if="previews[item.key] || item.image"
            :src="previews[item.key] || item.image"
            :alt="item.alt"
          />
          <span v-else class="logo-placeholder">
            <van-icon name="photograph" />
          </span>
          <img v-if="previews[item.key]" class="uploaded-icon" src="https://static.91fd.com/tonghui_life/shangchuanxieyi1.png" alt="已上传" />
        </span>
        <span class="upload-copy">点击上传{{ item.prefix }} <em>{{ item.highlight }}</em></span>
        <input type="file" accept="image/*" @change="choose($event, item.key)" />
      </label>
    </section>

    <div class="actions">
      <van-button block type="primary" @click="confirm">确定</van-button>
      <p>温馨提示：上传或拍摄身份证时请确保照片的完整性及清晰度，以免需要二次补充资料！</p>
    </div>
  </main>
</template>

<script>
import front from "../assets/images/id-card-front.png";
import back from "../assets/images/id-card-back.png";

export default {
  name: "ImageUpload",
  data: () => ({
    uploads: [
      { key: "front", prefix: "身份证", highlight: "人像面", alt: "身份证人像面示例", image: front },
      { key: "back", prefix: "身份证", highlight: "国徽面", alt: "身份证国徽面示例", image: back },
      { key: "photo", prefix: "", highlight: "logo合影照", alt: "logo合影照", image: "" },
    ],
    previews: {},
  }),
  created() {
    sessionStorage.removeItem("imageUploadComplete");
  },
  beforeDestroy() {
    Object.values(this.previews).forEach((preview) => URL.revokeObjectURL(preview));
  },
  methods: {
    choose(event, key) {
      const file = event.target.files[0];
      if (!file) return;
      if (this.previews[key]) URL.revokeObjectURL(this.previews[key]);
      this.$set(this.previews, key, URL.createObjectURL(file));
    },
    confirm() {
      const complete = this.uploads.every((item) => this.previews[item.key]);
      if (!complete) return this.$toast("请上传完整资料");
      sessionStorage.setItem("imageUploadComplete", "true");
      this.$router.replace({ path: "/infomation", query: { step: "upload" } });
    },
  },
};
</script>

<style lang="scss" scoped>
.image-upload-page {
  display: flex;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
  background: #fff;
  color: #72809a;
}
.upload-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 38px 12px;
  padding: 28px 16px 0;
}
.upload-item {
  position: relative;
  min-width: 0;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.preview-box {
  position: relative;
  display: flex;
  height: 122px;
  align-items: center;
  justify-content: center;
  padding: 9px;
  border: 1px solid #edf0f3;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(48, 65, 90, 0.09);
  background: #fff;
}
.preview-box::after {
  position: absolute;
  inset: 7px;
  border: 1px solid #f6f7f8;
  content: "";
  pointer-events: none;
}
.preview-box > img:not(.uploaded-icon) {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.logo-placeholder {
  display: flex;
  width: 76px;
  height: 76px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0fbfd;
  color: #27bce5;
  font-size: 48px;
}
.uploaded-icon {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  transform: translate(-50%, -50%);
  object-fit: contain;
}
.upload-copy {
  display: block;
  margin-top: 14px;
  white-space: nowrap;
}
.upload-copy em {
  color: #d38255;
  font-style: normal;
}
.upload-item input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.actions {
  margin-top: 100px;
  padding: 30px 16px 32px;
}
.actions .van-button {
  height: 47px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(90deg, #e4a06f, #bf7044);
  font-size: 16px;
}
.actions p {
  margin: 38px 5px 0;
  color: #edbe71;
  font-size: 15px;
  line-height: 1.8;
}
</style>
